import { createSvgIcon } from '@material-ui/core';

// this comes from a newer version of MUI, can be imported from there when we update to that version
export const HotelClassIcon = createSvgIcon(
  <>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="20px"
      viewBox="0 0 20 20"
      width="20px"
      fill="none"
    >
      <rect fill="none" height="20" width="20" />
      <path
        fill="currentColor"
        d="M7.06 8H1l4.94 3.93L4.06 18 9 14.25 13.94 18l-1.88-6.07L17 8h-6.06L9 2 7.06 8zm4.3-3.56.67 2.06h1.58L12.15 2l-.79 2.44zM16.9 10l-3.1 2.47 1.23 3.97L17.08 18l-1.55-5 3.77-3h-2.4z"
      />
    </svg>
    ;
  </>,
  'AiIcon',
);
